<template>
  <zt-dialog
    :append-to-body="true"
    :modal-append-to-body="false"
    :visible="value"
    @close="onClose"
    @closed="onClosed"
    :modal="modal"
    :title="'上传'+ typeName +'链接'"
  >
    <div class="title">请输入{{ typeName }}链接：</div>
    <zt-textarea v-model="sources" type="textarea" rows="6" :placeholder="`${ typeName }链接`"></zt-textarea>

    <div class="sub-desc" v-show="multiple">*多个{{ typeName }}链接可用逗号隔开</div>
    <zt-tip :msg="errorMessage" type="error"></zt-tip>

    <div slot="footer" class="dialog-footer">
      <zt-button @click="onClose" class="mr10">取 消</zt-button>
      <zt-button type="primary" @click="onConfirm" :loading="loading">
        确 定
        <template slot="loading">正在提交...</template>
      </zt-button>
    </div>
  </zt-dialog>
</template>

<script>
import ZtTip from '@cps/ZtTip';
import ZtTextarea from '@cps/ZtTextarea';
import ZtDialog from '@cps/ZtDialog';
import typeMixin from '../mixins/type';
export default {
  name: 'LinkDialog',
  mixins: [typeMixin],
  components: {
    ZtTextarea,
    ZtDialog,
    ZtTip,
  },
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: { type: Boolean, default: false },
    modal: { type: Boolean, default: true },
    // 多张图片
    multiple: { type: Boolean, default: false },
  },
  data: () => ({
    loading: false,
    errorMessage: '',
    sources: '',
  }),
  methods: {
    isIE() {
      if (!!window.ActiveXobject || 'ActiveXObject' in window) {
        return true;
      } else {
        return false;
      }
    },
    isIE11() {
      if (/Trident\/7\./.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
    async onConfirm() {
      this.errorMessage = '';

      // 字符串以逗号分割成数组 -> 清除前后空格 -> 清除空字符串
      let linkList = this.sources
        .split(/,|，/)
        .map((src) => src.trim())
        .filter((src) => src);
      if (!linkList.length)
        return (this.errorMessage = `无法获取链接${this.typeName}，请重新输入`);

      this.loading = true;
      // 检测资源的有效性
      let validateList = null;
      if (this.isImage) {
        validateList = await this.validateImages(linkList);
      } else {
        validateList = await this.validateVideos(linkList);
      }

      // 单独拿出错误的url
      const errorList = [];
      validateList.forEach((isSuccess, index) => {
        if (!isSuccess) {
          errorList.push(linkList[index]);
        }
      });
      // 提示用户有错误的url
      if (errorList.length) {
        const errorMessage = errorList.map((v, k) => `\n${k + 1}: ${v}`);
        this.$message.error(`已为您过滤部分无效的链接${errorMessage}`);
      }
      // 清除无效的url，并格式化成 [{ src }] 格式的数组
      linkList = linkList
        .filter((src, index) => validateList[index])
        .map((src) => ({ src }));

      this.$emit('submit', linkList);
      this.loading = false;
      this.onClose();
    },

    // 检测图片有效性
    async validateImages(imagesArr) {
      // 只支持是 String 或者 Array传入
      if (!(imagesArr instanceof Array)) {
        imagesArr = [imagesArr];
      }

      const queue = imagesArr.map(
        (src) =>
          new Promise((resolve) => {
            const image = new Image();
            image.src = src;
            if (image.complete) return resolve(true);
            image.onload = () => resolve(true);
            image.onerror = () => resolve(false);
          })
      );

      return await Promise.all(queue);
    },

    // 检测视频有效性
    async validateVideos(videosArray) {
      // 只支持是 String 或者 Array传入
      if (!(videosArray instanceof Array)) {
        videosArray = [videosArray];
      }

      const queue = videosArray.map(
        (src) =>
          new Promise((resolve) => {
            const $video = document.createElement('video');
            $video.style.opacity = 0;
            $video.src = src;
            document.body.appendChild($video);
            $video.oncanplay = () => {
              if (this.isIE() || this.isIE11()) {
                $video.removeNode(true);
              } else {
                $video.remove();
              }
              resolve(true);
            };
            $video.onerror = () => {
              if (this.isIE() || this.isIE11()) {
                $video.removeNode(true);
              } else {
                $video.remove();
              }
              resolve(false);
            };
          })
      );
      return await Promise.all(queue);
    },

    onClose() {
      this.$emit('input', false);
    },

    onClosed() {
      this.sources = '';
    },
  },
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  line-height: 44px;
  margin-bottom: 1px;
  color: $theme-textnormal;
}
.sub-desc {
  font-size: 12px;
  line-height: 17px;
  margin-top: 8px;
  color: $theme-textplaceholder;
}
.zt-tip {
  margin-top: 8px;
}
</style>